<template>
  <div class="analytics-container">
    <div class="dashboard-grid">
      <!-- Левая колонка с графиками -->
      <div class="left-column">
        <!-- График 1: Динамика по источнику (Bar Chart) -->
        <NewsBySourceChart />

        <!-- График 2: Динамика потока (Area Chart) -->
        <NewsFlowChart />
      </div>

      <!-- Правая колонка с таблицей -->
      <div class="right-column">
        <SourcesActivityTable />
      </div>
    </div>
  </div>
</template>

<script setup>
import NewsBySourceChart from "@/components/analytics/NewsBySourceChart.vue";
import NewsFlowChart from "@/components/analytics/NewsFlowChart.vue";
import SourcesActivityTable from "@/components/analytics/SourcesActivityTable.vue";
</script>

<style scoped>
.analytics-container {
  margin-top: 10px;
}

.dashboard-grid {
  display: grid;
  grid-template-columns: 1.15fr 1fr;
  gap: 24px;
}

@media (max-width: 1150px) {
  .dashboard-grid {
    grid-template-columns: 1fr;
  }
}

.left-column {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.right-column {
  display: flex;
  flex-direction: column;
}
</style>
